<rfx-grid-filter-control>
	<button
		mat-button
		type="button"
	>
        {{'COMMON.SEARCH'|translate}}
	</button>
</rfx-grid-filter-control>
